import { FC } from 'react';
import { Outlet } from 'react-router-dom';

export const PointExpiryRoot: FC = () => {
	return <Outlet />;
};
